import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { currency } from 'app/constants/currency.constants';
import { DataService, DateService, FormatService, HTTPService, HelperService } from 'app/services';
import { paymentTypeTitle } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { UpdateARLimitDialogComponent } from 'app/modules/shared/components';

import { CreateStatementDialogComponent } from '../create-statement-dialog/create-statement-dialog.component';

import { findIndex } from 'lodash';

@Component({
  selector: 'app-ar-account',
  templateUrl: './ar-account.component.html',
  styleUrls: ['./ar-account.component.scss'],
})
export class ArAccountComponent implements OnInit {
  @Input('customerData')
  set customerData(data: any) {
    if (data && Object.keys(data).length > 0) {
      this.customer = this.helperService.deepCopy(data);
      this.getAcountRevesable();
    }
  }
  @Input() estimate: any = {};
  @Input() chargeAccounts: any = {};
  @Input() currentShopId: any;
  @Input() isCustomerPaymentEnabled: boolean = false;

  cols = [
    { field: 'code', header: 'Credit memo ID', class: 'name' },
    { field: 'status', header: 'Status', class: 'status' },
    { field: 'amount', header: 'Amount', class: 'amount' },
    { field: 'firstMonth', header: '0-30', isShowSortIcon: false, className: 'amount' },
    { field: 'secondMonth', header: '30-60', isShowSortIcon: false, className: 'amount' },
    { field: 'thirdMonth', header: '60-90', isShowSortIcon: false, className: 'amount' },
    { field: 'MoreThanThreeMonths', header: '90+', isShowSortIcon: false, className: 'amount' },
    {
      field: 'total',
      header: 'Total',
      isShowSortIcon: false,
      className: 'rem-amount',
    },
    { field: 'remainingAmount', header: 'Remaining Amount', class: 'rem-amount' },
  ];

  @Input() isArAccountPermitted: boolean = false;
  statmentCols: any[] = [
    {
      field: 'createdAt',
      title: 'Created date',
      headerClass: 'created-date',
      dataClass: 'created-date',
      formatPipe: DatePipe,
      pipeArgs: 'MMM d, yyyy',
    },
    {
      field: 'name',
      title: 'Name',
      headerClass: 'name',
      dataClass: 'name',
    },
    {
      field: 'invoiceCount',
      title: 'Invoices',
      headerClass: 'invoices',
      dataClass: 'invoices',
    },
    {
      field: 'paidStatus',
      title: 'Payment status',
      headerClass: 'paid-status',
      dataClass: 'paid-status',
    },
    {
      field: 'sentSatus',
      title: 'Sent status',
      headerClass: 'sent-status',
      dataClass: 'sent-status',
    },
    {
      field: 'sendDate',
      title: 'Sent date',
      headerClass: 'sent-date',
      dataClass: 'sent-date hover-underline pointer font-color',
      formatPipe: DatePipe,
      pipeArgs: 'MMM d, yyyy',
    },
    {
      field: 'invoiceTotal',
      title: 'Invoice total',
      headerClass: 'invoice-total',
      dataClass: 'invoice-total',
      formatPipe: CurrencyPipe,
      pipeArgs: currency.USD,
    },
    {
      field: 'paidToDate',
      title: 'Paid to date',
      headerClass: 'paid-date',
      dataClass: 'paid-date',
      formatPipe: CurrencyPipe,
      pipeArgs: currency.USD,
    },
    {
      field: 'balanceDue',
      title: 'Balance due',
      headerClass: 'balance-due',
      dataClass: 'balance-due',
      formatPipe: CurrencyPipe,
      pipeArgs: currency.USD,
    },
  ];
  loading = true;
  accountsReceivableList: any = {
    customerAging: {},
    payments: {},
  };
  // default configuration
  recordsPerPage: number = 5;
  defaultSortField: string = 'createdAt';
  defaultSortOrder: number = -1;
  paramStatementId = '';
  // records
  records: any[] = [];
  totalRecords: number = 0;
  currentDateTime: any;
  // current page
  first: number = 0;
  // createdAtStart: 2000-01-01
  // createdAtEnd: 2024-02-10
  // filters
  filterState = {
    customerId: '',
    createdAtStart: '2000-01-01',
    createdAtEnd: '',
    isUnpaid: null,
    isPaidPartial: null,
    isPaidFull: null,
    isSent: null,
    orderStatus: null,
    sortField: 'createdAt',
    sortOrder: -1,
    skip: 0,
    limit: 5,
  };
  customer: any = {};
  creditMemo: any = [];
  usd: string = currency.USD;
  isQboConnected: boolean = false;
  revesableTotalRecords: any;
  accountsReceivableInvoices: any = [];
  noRecFound: any;
  totals: any;
  unpaidStatementAmt: number;
  totalUnpaidStatement: number;
  customerAppliedPayments: any[] = [];
  customerUnAppliedPayments: any[] = [];
  customerPaymentTable = {
    cols: [
      // { field: 'shop', name: 'Location', class: 'location' },
      { field: 'code', name: 'ID', class: 'id' },
      { field: 'group', name: 'Group', class: 'group' },
      { field: 'createdAt', name: 'Creation date', class: 'creationDate' },
      { field: 'appliedAt', name: 'Application date', class: 'applicationDate' },
      { field: 'paymentType', name: 'Payment type', class: 'payment-type' },
      { field: 'paymentMethod', name: 'Payment method', class: 'payment-method' },
      { field: 'orderCode', name: 'RO #', class: 'order-code' },
      { field: 'amount', name: 'Amount', class: 'amount' },
    ],
  };
  isCustomerPaymentLoading: boolean = true;

  constructor(
    private httpService: HTTPService,
    private formatService: FormatService,
    private dataService: DataService,
    private dateService: DateService,
    private helperService: HelperService,
    private dialogService: DialogService,
    private currencyPipe: CurrencyPipe
  ) {
    this.isQboConnected = this.helperService.getCompany().qbo;
  }

  async ngOnInit() {
    try {
      this.currentDateTime = await this.httpService.getServerTime();
    } catch (err) {
      console.log(err);
    }
    this.currentDateTime = this.dateService.getCurrentDateTimeTz(this.currentDateTime);
    this.currentDateTime = this.dateService.formatDate(this.currentDateTime, datetimeFormat.yyymmdd);
    this.getAcountRevesable();
    this.getCustomerPayments();
    this.getCustomerStatementStats();
    if (this.isQboConnected) {
      const index = findIndex(this.cols, { field: 'status' });

      if (this.cols[index + 1].field !== 'qboSyncStatus') {
        this.cols.splice(index + 1, 0, { field: 'qboSyncStatus', header: '	QBO status', class: 'status' });
      }
    }
  }

  async getCustomerPayments() {
    try {
      this.isCustomerPaymentLoading = true;
      const customerPayments = (await this.httpService.getCustomerPayments(this.customer._id)) as any[];
      console.log('customerPayments ===>>>', customerPayments);

      Object.keys(customerPayments).forEach((key) => {
        const payments = customerPayments[key].map((customerPayment: any) => {
          const payment: any = {
            code: customerPayment.code,
            group: 'Payment',
            orderCode: '',
            paymentType: paymentTypeTitle[customerPayment.paymentType],
            paymentMethod: customerPayment.paymentMethod?.name,
            amount: this.currencyPipe.transform(customerPayment.amount, this.usd),
            createdAt: '',
            appliedAt: '',
          };

          if (customerPayment.paymentDate) {
            const createdAt = this.dateService.getCurrentDateTimeTz(new Date(customerPayment.paymentDate).getTime());
            payment.createdAt = this.dateService.formatDate(createdAt, datetimeFormat.mmmdyyyy);
          }

          if (customerPayment.paymentAppliedDate) {
            const appliedAt = this.dateService.getCurrentDateTimeTz(new Date(customerPayment.paymentAppliedDate).getTime());
            payment.appliedAt = this.dateService.formatDate(appliedAt, datetimeFormat.mmmdyyyy);
          }

          if (customerPayment.estimate?.code) {
            payment.orderCode = customerPayment.estimate?.code;
          }

          return payment;
        });

        if (key === 'applied') {
          this.customerAppliedPayments = payments;
        } else {
          this.customerUnAppliedPayments = payments;
        }
      });
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isCustomerPaymentLoading = false;
    }
  }

  setAccountLimit(data) {
    let allowedLimit = this.customer?.chargeAccountDetails?.allowedLimit || 0;
    let unlimited = this.customer?.chargeAccountDetails?.unlimited || false;
    if (!allowedLimit && !unlimited) {
      // set value from default
      if (this.customer.isFleetCustomer) {
        allowedLimit = this.chargeAccounts?.fleetCustomerLimit?.value;
        unlimited = this.chargeAccounts?.fleetCustomerLimit?.unlimited;
      } else {
        allowedLimit = this.chargeAccounts?.regularCustomerLimit?.value;
        unlimited = this.chargeAccounts?.regularCustomerLimit?.unlimited;
      }
    }
    this.customer.chargeAccountDetails = {
      allowedLimit,
      usedLimit: this.accountsReceivableList?.customerAging?.total || 0,
      unlimited,
      availableLimit: allowedLimit - (this.accountsReceivableList?.customerAging?.total || 0),
    };
  }

  openStatementModal(statementId: string = '') {
    this.helperService.openPageInNewExistingTab(`/customer/customer-center/${this.customer._id}?statement&openModal=true`, this.customer._id);
  }

  /**
   * Open statement modal
   * @param statementId
   */
  openExsistingStatementModal(statementId: string = '') {
    let dataMode = statementId ? 'edit' : null;
    const ref = this.dialogService.open(CreateStatementDialogComponent, {
      width: '1110px',
      styleClass: 'add-dialog add-statement-modal',
      showHeader: false,
      data: { statementId, customerId: this.filterState.customerId, dataMode },
    });
    const onClose = ref.onClose.subscribe((close: any) => {
      this.getStatmenList();
      onClose.unsubscribe();
    });
  }

  openBulkPaymentModal(statementId: string = '') {
    this.helperService.openPageInNewExistingTab(`/customer/customer-center/${this.customer._id}?statement&openBulkModal=true`, this.customer._id);
  }

  /**
   * on list load
   */
  async onLazyLoad(params): Promise<void> {
    try {
      const { sortField, sortOrder, first, rows } = params;
      // if (!this.filterState.createdAtEnd || !this.filterState.createdAtStart) {
      //   return;
      // }

      this.loading = true;
      this.filterState.customerId = this.customer._id;
      this.filterState.createdAtEnd = this.currentDateTime;
      // to preserve initial sorting
      if (sortField && sortOrder) {
        this.filterState.sortField = sortField;
        this.filterState.sortOrder = sortOrder;
      }

      this.filterState.skip = first;
      this.filterState.limit = rows;
      // this.statementTabFilters();
      this.getStatmenList();
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.loading = false;
    }
  }

  async getStatmenList() {
    const data = await this.httpService.getStatementList(this.filterState);

    this.totalRecords = data.metaData.totalRecords;
    this.records = this.formatService.formatStatementList(data.records);
  }

  updateArLimit(value) {
    const unlimited = this.customer?.chargeAccountDetails?.unlimited;
    const ref = this.dialogService.open(UpdateARLimitDialogComponent, {
      width: '35%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        customerARLimit: value,
        availableLimit: this.customer?.chargeAccountDetails.availableLimit,
        isCurrentUnlimted: unlimited,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const arLimitPayload = {
          limit: Number(data),
          unlimited: false,
          _id: this.customer._id,
        };
        try {
          this.httpService.updateCustomerArLimit(arLimitPayload).then((res) => {
            if (res) {
              this.customer.chargeAccountDetails.allowedLimit = data;
              this.customer.chargeAccountDetails.unlimited = false;
              this.setAccountLimit(data);
              this.helperService.showToaster('success', 'New AR limit updated');
              this.dataService.sendData(this.dataService.typePassData('ar-account-limit-updated', {}));
            }
          });
        } catch (err) {
          console.log(err);
        } finally {
          onClose.unsubscribe();
        }
      } else {
        onClose.unsubscribe();
      }
    });
  }

  getAcountRevesable() {
    this.loading = true;
    const data = {
      isFleetCustomer: this.customer.isFleetCustomer,
      customerId: this.customer._id,
    };
    this.httpService.getReportAccountsReceivableHistory(data).then(
      (res: any) => {
        this.loading = false;

        this.accountsReceivableList.customerAging = res?.customerAging;
        this.accountsReceivableList.payments = res?.payments;
        this.setAccountLimit(this.customer);
      },
      (error) => {
        this.loading = false;
        this.helperService.showToaster('error', error);
      }
    );
  }

  getCustomerStatementStats() {
    this.loading = true;
    this.httpService.getCustomerStatementStats(this.customer._id).then(
      (data) => {
        this.loading = false;
        if (data && data[0]) {
          this.unpaidStatementAmt = data[0]?.unpaid;
          this.totalUnpaidStatement = data[0]?.count;
        }
      },
      (err) => {
        this.loading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  openCustomerPaymentsDialog() {}
}
